import TTag from './Tag.vue'

export const Tag = TTag
